import { render, staticRenderFns } from "./RewardsHistory.vue?vue&type=template&id=0466cd18"
import script from "./rewards-history.ts?vue&type=script&lang=ts&external"
export * from "./rewards-history.ts?vue&type=script&lang=ts&external"
import style0 from "./rewards-history.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports